module.exports = __webpack_public_path__ + "img/elegance.dcb05069.png";